export const SET_LOADING = 'SET_LOADING';
export const SET_TYPE = 'SET_TYPE';
export const SET_PARAS = 'SET_PARAS';
export const SET_STARTWITHLOREM = 'SET_STARTWITHLOREM';
export const SET_TEXT = 'SET_TEXT';


// WEBPACK FOOTER //
// ./src/constants.js